import GokuDataGrid from '@/components/GokuDataGrid'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getAffiliateCandidates } from '@/modules/Affiliate/services'
import { AffiliateCandidateContact } from '@/modules/Affiliate/types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { affiliateCandidateColumns } from './columns'

const Candidates = () => {
    const { t } = useTranslation('affiliate')
    const navigate = useNavigate()
    const columns = useMemo(
        () => affiliateCandidateColumns(t, navigate),
        [navigate, t]
    )

    return (
        <div className="my-2">
            <GokuDataGrid<AffiliateCandidateContact, AffiliateCandidateContact>
                apiCall={getAffiliateCandidates}
                columns={columns}
                reactQueryKey={`${QUERY_KEYS.AFFILIATES}-candidates`}
                dataGridProps={{
                    getRowId: (row) => row?.customer_contact_id,
                }}
                searchPlaceholder={t('search_candidates')}
            />
        </div>
    )
}

export default Candidates
